export const getStayList = (locale: 'ja' | 'en') => {
  switch (locale) {
    case 'en':
      return StayList_EN
    case 'ja':
    default:
      return StayList_JA
  }
}

export type stayType = {
  image: string
  alt: string
}

export const StayList_JA: stayType[] = [
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails01_jp.webp',
    alt: '間取り'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails02_jp.webp',
    alt: 'テラス'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails03_jp.webp',
    alt: '車内全体'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails04_jp.webp',
    alt: 'ダブルベッド'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails05_jp.webp',
    alt: '2段ベッド'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails06_jp.webp',
    alt: 'ソファー(ベッド) ※ソファー使用時'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails07_jp.webp',
    alt: 'ソファー(ベッド) ※ベッド使用時'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails08_jp.webp',
    alt: 'シャワー＆トイレ'
  }
]

export const StayList_EN: stayType[] = [
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails01_en.webp',
    alt: 'Trailer Layout'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails02_en.webp',
    alt: 'Patio'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails03_en.webp',
    alt: 'Interior'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails04_en.webp',
    alt: 'Double Bed'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails05_en.webp',
    alt: 'Bunk Bed'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails06_en.webp',
    alt: 'Sofa Bed (Sofa Mode)'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails07_en.webp',
    alt: 'Sofa Bed (Bed Mode)'
  },
  {
    image: '/assets/pages/stay/trailer/ImageStayDetails08_en.webp',
    alt: 'Shower & Toilet'
  }
]
